<template>
  <div class="batch-card-actions">
    <!--MODALS-->
    <modal
      ref="loadingReceiptModal"
      template="loading"
      title="Aguarde"
      ref-name="loadingReceiptModal"
    >
      <p>Gerando recibo...</p>
    </modal>

    <modal
      ref="loadingGettingSamples"
      template="loading"
      title="Aguarde"
      ref-name="loadingGettingSamples"
    >
      <p>Carregando...</p>
    </modal>

    <modal
      ref="printOpenBatchModal"
      template="question"
      icon-type="impress"
      title="Lote Aberto"
      ref-name="printOpenBatchModal"
      second-button-style="btn-nonenary"
      first-button-sub-text="Manter o lote aberto e imprimir etiquetas"
      :first-button-disabled="areAllSamplesPrinted"
      :second-button-sub-text="secondButtonMessage"
      :close-button-enabled="true"
      class="openBatchModal"
      :warning-enabled="true"
      :warning-text="'Ao imprimir, serão consideradas apenas etiquetas não impressas. <br/> Para reimpressão,'"
      :warning-action="'clique aqui'"
      @first-cta="closeAndPrint({ printOnlySamples: true })"
      @second-cta="closeAndPrint({ printOnlySamples: false })"
      @warning-event="pushToBatchDetails()"
    >
      <p>Este lote contém:</p>
      <p v-if="totalSamplesPrinted">
        <strong>
          - {{ totalSamplesPrinted }} amostra
          <template v-if="totalSamplesPrinted > 1">s</template>
          impressa
          <template v-if="totalSamplesPrinted > 1">s</template>
        </strong>
        <span v-if="totalSamplesUnprinted > 0">e</span>
      </p>
      <p v-if="totalSamplesUnprinted">
        <strong>
          - {{ totalSamplesUnprinted }} amostra
          <template v-if="totalSamplesUnprinted > 1">s</template>
          não impressa
          <template v-if="totalSamplesUnprinted > 1">s</template>
        </strong>
      </p>
      <p>
        Você pode mantê-lo aberto e adicionar até {{ batch.capability - samplesFromBatchSelected.length }} nova
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">s</template>
        amostra
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">s</template>
        .
        <br />
        <strong>O que deseja fazer?</strong>
      </p>
    </modal>

    <!-- Web Socket Print -->
    <modal
      ref="webSocketPrintOpenBatchModal"
      template="question"
      icon-type="impress"
      title="Lote Aberto"
      ref-name="printOpenBatchModal"
      second-button-style="btn-nonenary"
      first-button-sub-text="Manter o lote aberto e imprimir etiquetas"
      :first-button-disabled="areAllSamplesPrinted"
      :second-button-sub-text="secondButtonMessage"
      :close-button-enabled="true"
      class="openBatchModal"
      :warning-enabled="true"
      :warning-text="'Ao imprimir, serão consideradas apenas etiquetas não impressas. <br/> Para reimpressão,'"
      :warning-action="'clique aqui'"
      @first-cta="webSocketPrintCloseAndPrint({ printOnlySamples: true })"
      @second-cta="webSocketPrintCloseAndPrint({ printOnlySamples: false })"
      @warning-event="pushToBatchDetails()"
    >
      <p>Este lote contém:</p>
      <p v-if="totalSamplesPrinted">
        <strong>
          - {{ totalSamplesPrinted }} amostra
          <template v-if="totalSamplesPrinted > 1">s</template>
          impressa
          <template v-if="totalSamplesPrinted > 1">s</template>
        </strong>
        <span v-if="totalSamplesUnprinted > 0">e</span>
      </p>
      <p v-if="totalSamplesUnprinted">
        <strong>
          - {{ totalSamplesUnprinted }} amostra
          <template v-if="totalSamplesUnprinted > 1">s</template>
          não impressa
          <template v-if="totalSamplesUnprinted > 1">s</template>
        </strong>
      </p>
      <p>
        Você pode mantê-lo aberto e adicionar até {{ batch.capability - samplesFromBatchSelected.length }} nova
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">s</template>
        amostra
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">s</template>
        .
        <br />
        <strong>O que deseja fazer?</strong>
      </p>
    </modal>
    <!-- Web Socket Fim -->

    <!-- Pra Impressão Web -->
    <modal
      ref="printOpenBatchModalWeb"
      template="question"
      icon-type="impress"
      title="Lote Aberto"
      ref-name="printOpenBatchModalWeb"
      second-button-style="btn-nonenary"
      first-button-sub-text="Manter o lote aberto e seguir para impressão Web"
      :first-button-disabled="areAllSamplesPrinted"
      :second-button-sub-text="secondButtonMessagePrintWeb"
      :close-button-enabled="true"
      class="openBatchModal"
      :warning-enabled="true"
      :warning-text="'Ao imprimir, serão consideradas apenas etiquetas não impressas. <br/> Para reimpressão,'"
      :warning-action="'clique aqui'"
      @first-cta="showPDF(batch)"
      @second-cta="closeAndPrintWeb({ printOnlySamples: false, batch })"
      @warning-event="pushToBatchDetails()"
    >
      <p>Este lote contém:</p>
      <p v-if="totalSamplesPrinted">
        <strong>
          - {{ totalSamplesPrinted }} amostra
          <template v-if="totalSamplesPrinted > 1">s</template>
          impressa
          <template v-if="totalSamplesPrinted > 1">s</template>
        </strong>
        <span v-if="totalSamplesUnprinted > 0">e</span>
      </p>
      <p v-if="totalSamplesUnprinted">
        <strong>
          - {{ totalSamplesUnprinted }} amostra
          <template v-if="totalSamplesUnprinted > 1">s</template>
          não impressa
          <template v-if="totalSamplesUnprinted > 1">s</template>
        </strong>
      </p>
      <p>
        Você pode mantê-lo aberto e adicionar até {{ batch.capability - samplesFromBatchSelected.length }} nova
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">s</template>
        amostra
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">s</template>
        .
        <br />
        <strong>O que deseja fazer?</strong>
      </p>
    </modal>

    <md-dialog
      id="printingClosedBatchModal"
      ref="printingClosedBatchModal"
      md-title
      :md-esc-to-close="false"
      :md-click-outside-to-close="false"
      class="export-print-tag modals print-tag-modal-details print-tag-modal-print"
    >
      <div class="print-tag-modal-column__one">
        <md-dialog-title>
          <div
            v-if="printingLoading"
            class="print-tag-modal-details__title"
          >
            <svg-loader src="/static/images/icon-correct-success.svg" />
            Imprimindo Lote Completo
          </div>
          <div
            v-else
            class="print-tag-modal-details__title"
          >
            <svg-loader src="/static/images/icon-correct-success.svg" />
            Lote Completo
          </div>
        </md-dialog-title>

        <md-dialog-content>
          <div
            v-if="printingLoading"
            class="print-tag-modal-details__description"
          >
            <p>
              <span>Aguarde...</span>
            </p>
            <p>As etiquetas estão sendo impressas.</p>
          </div>

          <div
            v-else
            class="print-tag-modal-details__description"
          >
            <p>
              <span>Impressão concluída com sucesso.</span>
            </p>
            <p>A etiqueta inicial será sempre a do lote, seguida das amostras inclusas</p>
          </div>

          <md-button
            v-if="printingLoading"
            class="btn btn-primary print-tag-modal-details__button button-single"
            disabled
          >
            AGUARDE
          </md-button>
          <md-button
            v-else
            id="btnTurnBackToPrintTagsList"
            class="btn btn-primary print-tag-modal-details__button button-single"
            @click="closeLoadingPrintingModal()"
          >
            Voltar para lotes
          </md-button>
        </md-dialog-content>
      </div>
      <div class="print-tag-modal-column__two">
        <transition
          name="fade"
          mode="out-in"
        >
          <div>
            <div class="loaded">
              <svg-loader
                v-if="!printingLoading"
                src="/static/images/icon-correct-success.svg"
              />
              <img
                src="/static/images/label-batch.svg"
                alt="Etiqueta do Lote"
              />
            </div>
            <div class="loaded">
              <svg-loader
                v-if="!printingLoading"
                src="/static/images/icon-correct-success.svg"
              />
              <img
                src="/static/images/label-sample.svg"
                alt="Etiqueta da Amostra"
              />
            </div>
          </div>
        </transition>
      </div>
    </md-dialog>

    <!--BUTTONS-->

    <template v-if="!batch.isPrinted">
      <md-button
        :id="'btn-print-tag-' + index"
        class="btn btn-nonenary"
        @click="validatePrintingSystem(batch)"
      >
        <svg-loader src="/static/images/icon-print-alternative.svg" />
        <span v-if="batchesCurrentTab === 'aol20'">IMPRIMIR ETIQUETAS</span>
        <template v-else>
          <span v-if="batch.state === 'CLOSED'">IMPRIMIR LOTE</span>
          <span v-else>FECHAR E IMPRIMIR LOTE</span>
        </template>
      </md-button>
      <md-button
        v-if="batchesCurrentTab === 'aol20'"
        :id="'btn-print-receipt-' + index"
        class="btn btn-nonenary"
        @click="loadingBatchesReceipt(batch)"
      >
        <svg-loader src="/static/images/icon-print-alternative.svg" />
        <span>IMPRIMIR RECIBO</span>
      </md-button>
    </template>
    <template v-else>
      <md-button
        :id="'btn-reprint-receipt-' + index"
        class="btn btn-nonenary"
        @click="validatePrintingSystem(batch)"
      >
        <svg-loader src="/static/images/icon-print-alternative.svg" />
        <span v-if="batchesCurrentTab === 'aolWs'">REIMPRIMIR LOTE</span>
        <span v-else>REIMPRIMIR ETIQUETAS</span>
      </md-button>
      <md-button
        v-if="$route.name === 'Impressão de Etiquetas - Lotes'"
        :id="'btn-show-batch-details-' + index"
        class="btn btn-nonenary"
        @click="pushToBatchDetails(batch)"
      >
        <svg-loader src="/static/images/icon-open-printed-batch.svg" />
        <span>VISUALIZAR LOTE</span>
      </md-button>
      <md-button
        v-else
        :id="'btn-reprint-receipt-' + index"
        class="btn btn-nonenary"
        @click="loadingBatchesReceipt(batch)"
      >
        <svg-loader src="/static/images/icon-print-alternative.svg" />
        <span>IMPRIMIR RECIBO</span>
      </md-button>
    </template>

    <PrinterModal ref="printerModal" />
    <PrinterPluginDownloadModal ref="printerPluginDownloadModal" />
  </div>
</template>

<script>
import mixin from './../../BatchesMixin';
import printerValidationMixin from '../../../printerValidationMixin';
import { mapActions, mapGetters } from 'vuex';
import notify from '@/api/notification';
import label from '@/api/label';
import pdfkit from '../../../../../libs/pdfkit';
import blobstream from '../../../../../libs/blob-stream';
import PrinterModal from '@/components/common/printer/PrinterModal';
import PrinterPluginDownloadModal from '@/components/common/printer/PrinterPluginDownloadModal.vue';

const SAMPLES_UNPRINTED_MESSAGE = 'Fechar o lote e imprimir etiquetas';
const SAMPLES_UNPRINTED_MESSAGE_WEB = 'Fechar o lote e seguir para impressão de etiquetas web';
const ALL_SAMPLES_PRINTED_MESSAGE = 'fechar e imprimir a etiqueta de lote';
const ALL_SAMPLES_PRINTED_MESSAGE_WEB = 'fechar e seguir para impressão web de lote';

export default {
  name: 'BatchCardActions',
  components: {
    PrinterModal,
    PrinterPluginDownloadModal,
  },
  mixins: [mixin, printerValidationMixin],
  props: {
    batch: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    big: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    printingLoading: false,
  }),
  computed: {
    ...mapGetters(['batchesSamplesPrintingStatus', 'batchesCurrentTab', 'profile', 'toggle', 'webSocketStatus', 'defaultPrinter']),
    areAllSamplesPrinted: function () {
      if (this.samplesFromBatchSelected.length > 0) {
        return this.samplesFromBatchSelected.every(elem => elem.printed_status);
      } else {
        return false;
      }
    },
    totalSamplesPrinted: function () {
      if (this.samplesFromBatchSelected.length > 0) {
        return this.samplesFromBatchSelected.filter(elem => elem.printed_status).length;
      }
    },
    totalSamplesUnprinted: function () {
      if (this.samplesFromBatchSelected.length > 0) {
        return this.samplesFromBatchSelected.filter(elem => !elem.printed_status).length;
      }
    },
    isBatchFromWS: function () {
      return this.batchSelected.source === this.BATCH_SOURCE_SYSTEM_WS;
    },
    secondButtonMessage: function () {
      return this.areAllSamplesPrinted ? ALL_SAMPLES_PRINTED_MESSAGE : SAMPLES_UNPRINTED_MESSAGE;
    },
    secondButtonMessagePrintWeb: function () {
      return this.areAllSamplesPrinted ? ALL_SAMPLES_PRINTED_MESSAGE_WEB : SAMPLES_UNPRINTED_MESSAGE_WEB;
    },
  },
  watch: {
    batchesPrintingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_PRINTING':
          this.$analytics.pushAnalyticsEvent('vpageview', {
            page: '/batches/printing-modal',
            'id-usuario': this.profile.id,
            'id-lab': this.profile.id_laboratory,
            nlab: this.profile.laboratoryName,
          });
          if (this.printingLoading === false) {
            this.openLoadingPrintingModal();
          }
          break;
        case 'STATUS_MISSING_CLIENT':
          this.closeLoadingPrintingModal();
          break;
        default:
          break;
      }
    },
    batchesSamplesPrintingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_FAILED':
        case 'STATUS_MISSING_CLIENT':
          this.closeLoadingPrintingModal();
          break;
        default:
          break;
      }
    },
  },
  methods: {
    ...mapActions(['printBatchSamples', 'webSocketPrintBatchSamples']),
    getSampleSortColumn(value) {
      return value === 'inclusion_order' ? null : value || null;
    },
    handlePrint(batch) {
      this.loadingBatchesReceipt(batch);
    },
    loadingBatchesReceipt(batch) {
      this.openLoadingReceptModal();
      this.getSamplesByBatchId(this.batch.id)
        .then(response => {
          let samples = response.data;
          this.printReceiptBatchSamples({ samples, batch }).then(() => {
            this.closeLoadingReceptModal();
          });
        })
        .catch(() => {
          this.closeLoadingReceptModal();
          notify({
            title: 'AVISO:',
            message: 'Não foi possível buscar informações de lote no momento.',
            action: {
              title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
              handler: this.pushToSamplesPage,
            },
          });
          this.pushEventToAnalytics('Impressão de Recibo - Falha ao buscar amostras do lote por ID');
        });
      this.pushEventToAnalytics('Impressão de recibo de lote');
    },
    validateBeforePrint(batch) {
      if (batch.source !== 'AOL2') {
        this.printBatchTag(batch);
      } else {
        this.batchSelected = batch;
        this.batchSetCardStatus(batch.state !== this.BATCH_STATE_PRINTED);
        this.openLoadingGettingSamplesModal();

        this.getSamplesByBatchId(batch.id)
          .then(response => {
            this.closeLoadingGettingSamplesModal();
            this.samplesFromBatchSelected = response.data;
            if (this.samplesFromBatchSelected.length < this.batch.capability && this.batchSelected.state === this.BATCH_STATE_OPENED) {
              this.openQuestionModal();
            } else {
              this.printBatchAndSamples({ printOnlySamplesPrinted: null });
              this.pushEventToAnalytics(batch.isPrinted ? 'Reimpressão de Lote AOL - Impresso' : 'Impressão de Lote AOL - Não impresso - Fechado');
            }
          })
          .catch(() => {
            this.closeLoadingGettingSamplesModal();
            notify({
              title: 'AVISO:',
              message: 'Não foi possível buscar informações de lote no momento.',
              action: {
                title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
                handler: this.pushToSamplesPage,
              },
            });
            this.pushEventToAnalytics('Impressão de Lote - Falha ao buscar amostras do lote por ID');
          });
      }
    },
    async validateBeforeWebSocketPrint(batch) {
      await this.executeWithPrinterValidation(() => {
        if (batch.source !== 'AOL2') {
          this.webSocketPrintBatchTag(batch);
        } else {
          this.batchSelected = batch;
          this.batchSetCardStatus(batch.state !== this.BATCH_STATE_PRINTED);
          this.openLoadingGettingSamplesModal();

          this.getSamplesByBatchId(batch.id)
            .then(response => {
              this.samplesFromBatchSelected = response.data;

              this.batchSelected = {
                ...this.batchSelected,
                samples: response.data,
              };

              if (this.samplesFromBatchSelected.length < this.batch.capability && this.batchSelected.state === this.BATCH_STATE_OPENED) {
                this.openQuestionWebSocketModal();
              } else {
                this.webSocketPrintBatchAndSamples({ printOnlySamplesPrinted: null });
              }
            })
            .catch(() => {
              notify({
                title: 'AVISO:',
                message: 'Não foi possível buscar informações de lote no momento.',
                action: {
                  title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
                  handler: this.pushToSamplesPage,
                },
              });
            })
            .finally(() => {
              this.closeLoadingGettingSamplesModal();
            });
        }
      });
    },
    validateBeforePrintWeb(batch) {
      if (batch.source !== 'AOL2') {
        this.printBatchTag(batch);
      } else {
        this.batchSelected = batch;
        this.batchSetCardStatus(batch.state !== this.BATCH_STATE_PRINTED);
        this.openLoadingGettingSamplesModal();

        this.getSamplesByBatchId(batch.id)
          .then(response => {
            this.closeLoadingGettingSamplesModal();
            this.samplesFromBatchSelected = response.data;
            if (this.samplesFromBatchSelected.length < this.batch.capability && this.batchSelected.state === this.BATCH_STATE_OPENED) {
              this.openQuestionModalWeb();
            } else {
              //this.printBatchAndSamples({ printOnlySamplesPrinted: null })
              this.showPDF(batch);
              this.pushEventToAnalytics(batch.isPrinted ? 'Reimpressão de Lote AOL - Impresso' : 'Impressão de Lote AOL - Não impresso - Fechado');
            }
          })
          .catch(() => {
            this.closeLoadingGettingSamplesModal();
            notify({
              title: 'AVISO:',
              message: 'Não foi possível buscar informações de lote no momento.',
              action: {
                title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
                handler: this.pushToSamplesPage,
              },
            });
            this.pushEventToAnalytics('Impressão de Lote - Falha ao buscar amostras do lote por ID');
          });
      }
    },
    showPDF(batch) {
      const doc = new pdfkit({ size: [165.86, 83.73] });
      const stream = doc.pipe(blobstream());
      var indice;
      var ind = 0;
      this.createBatchLabel(doc, batch);
      this.getSamplesByBatchId(batch.id)
        .then(response => {
          var samples = response.data;
          samples.forEach((element, index) => {
            indice = index;
            label.getLabel(element.bar_code).then(response => {
              var samples = response.data;
              samples.forEach(async element => {
                this.createSampleLabel(doc, element, indice, ind, stream);
                ind++;
              });
            });
          });
        })
        .catch(() => {
          this.closeLoadingReceptModal();
          notify({
            title: 'AVISO:',
            message: 'Não foi possível buscar informações de lote no momento.',
            action: {
              title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
              handler: this.pushToSamplesPage,
            },
          });
          this.pushEventToAnalytics('Impressão de Recibo - Falha ao buscar amostras do lote por ID');
        });
    },
    createSampleLabel(doc, element, indice, ind, stream) {
      let str = element.label;
      let regex, label, name, infos, barcode, exam, examDescription, mnemonic, urgent, minimumVolume;
      let labelType = str.substring(1, 3);

      if (labelType === 'XA') {
        regex = /(?<=FD)(.*?)(?=FS)/g;
        label = str.match(regex);
        name = label[0].replace(/['"]+/g, '').replace(/['^]+/g, '');
        infos = label[1].replace(/['"]+/g, '').replace(/['^]+/g, '');
        barcode = label[3].replace(/['"]+/g, '').replace(/['^]+/g, '');
        exam = label[4].replace(/['"]+/g, '').replace(/['^]+/g, '');
        examDescription = label[5].replace(/['"]+/g, '').replace(/['^]+/g, '');
        mnemonic = label[6].replace(/['"]+/g, '').replace(/['^]+/g, '');
      } else {
        regex = /"(?:\\"|[^"])*"/g;
        label = str.match(regex);
        name = label[0].replace(/['"]+/g, '');
        infos = label[1].replace(/['"]+/g, '');
        barcode = label[3].replace(/['"]+/g, '');
        exam = label[4].replace(/['"]+/g, '');
        examDescription = label[5].replace(/['"]+/g, '');
        mnemonic = label[7].replace(/['"]+/g, '');
        urgent = label[8].replace(/['"]+/g, '').replace(/['^]+/g, '');
        minimumVolume = label[6].replace(/['"]+/g, '');
      }
      doc.fontSize(6).text(name, {
        width: 150,
        height: 10,
        align: 'left',
      });
      doc.fontSize(6).text(infos, {
        width: 150,
        height: 15,
        align: 'left',
      });
      doc.image(this.textToBase64Barcode(barcode, 'itf'), 15, 25, { width: 120, height: 30 });
      doc.fontSize(6).text(exam, 10, 55, {
        align: 'left',
      });
      doc.fontSize(6).text(examDescription, 10, 62, {
        align: 'left',
      });
      if (minimumVolume !== '') {
        doc.fontSize(6).text('VOLUME MÍNIMO:' + minimumVolume, 10, 68, {
          align: 'left',
        });
      }
      if (urgent !== '') {
        doc.save();
        doc.rotate(90, { origin: [160, 20] });
        doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000');
        doc.fillColor('white').fontSize(6).text(urgent, 160, 32).fill('black');
        doc.rotate(90 * -1, { origin: [160, 20] });
        doc.restore();
      }
      doc.rect(123, 57, 33, 10).fillAndStroke('#black', '#000');
      doc.fillColor('white').fontSize(8).text(mnemonic, 123, 59).fill('black');
      if (ind < indice) {
        doc.addPage();
      }
      if (ind === indice) {
        doc.end();
        stream.on('finish', function () {
          const url = stream.toBlobURL('application/pdf');
          window.open(url);
        });
      }
    },
    createBatchLabel(doc, batch) {
      const date = new Date(batch.created_at.substring(0, 19));

      doc.fontSize(8).text(batch.barcode, {
        width: 55,
        height: 10,
        align: 'left',
      });
      doc.fontSize(6).text('Amostras:' + batch.total_samples, 10, 10, {
        align: 'right',
      });
      doc.image(this.textToBase64Barcode(batch.barcode, 'code39'), 12, 20, { width: 125, height: 40 });
      doc.fontSize(6).text(this.profile.id_laboratory, 10, 65, {
        align: 'left',
      });
      doc.fontSize(6).text(date.toLocaleString('pt-BR'), 25, 65, {
        align: 'left',
      });
      doc.fontSize(8).text('NTO-' + batch.label.substring(0, 3), 10, 72, {
        align: 'left',
      });
      doc.fontSize(8).text(':' + this.getPackagingStatusName(batch.packagingId), 45, 72, {
        align: 'left',
      });

      if (batch.urgent === true) {
        doc.save();
        doc.rotate(90, { origin: [160, 20] });
        doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000');
        doc.fillColor('white').fontSize(6).text('URGENCIA', 160, 32).fill('black');
        doc.rotate(90 * -1, { origin: [160, 20] });
        doc.restore();
      }

      doc.rect(112, 70, 33, 10).fillAndStroke('#black', '#000');

      doc.save();
      doc.rotate(90, { origin: [15, 10] });
      doc.rect(15, 20, 68, 4).fillAndStroke('#black', '#000');

      doc.rotate(90 * -1, { origin: [15, 10] });
      doc.restore();

      doc
        .fillColor('white')
        .fontSize(8)
        .text(batch.mnemonic + '.' + batch.sequence, 112, 72)
        .fill('black');
      doc.addPage();
    },
    getPackagingStatusName(batch) {
      switch (batch) {
        case 25:
          return 'Congelado';
        case 26:
          return 'Refrigerado';
        case 27:
          return 'Ambiente';
        case 208:
          return 'Refrigerado Seco';
        default:
          return 'Outros';
      }
    },
    validatePrintingSystem(batch) {
      if (this.toggle.webPrinting) {
        this.validateBeforePrintWeb(batch);
      } else if (this.toggle.printerPlugin) {
        this.validateBeforeWebSocketPrint(batch);
      } else {
        this.validateBeforePrint(batch);
      }
    },
    textToBase64Barcode(barcode, format) {
      var JsBarcode = require('jsbarcode');
      var canvas = document.createElement('canvas');
      JsBarcode(canvas, barcode, { format: format, displayValue: false });
      return canvas.toDataURL('image/png');
    },
    pushToSamplesPage() {
      this.$router.push({
        path: '/print-tag/samples/',
        query: this.$route.query,
      });
    },
    webSocketPrintBatchAndSamples({ printOnlySamplesPrinted }) {
      this.printingLoading = true;
      this.openLoadingPrintingModal();

      const batchToTransmit = {
        ...this.batchSelected,
        printOnlyBatchTag: printOnlySamplesPrinted === null ? false : this.areAllSamplesPrinted || this.isBatchFromWS,
        onlySamplesPrinted: printOnlySamplesPrinted,
        sampleSortColumn: this.getSampleSortColumn(this.batchSelected?.printSortSelected?.value),
      };

      this.webSocketPrintAndTransmit(batchToTransmit).then(() => {
        this.closeLoadingPrintingModal();
      });
    },
    printBatchAndSamples({ printOnlySamplesPrinted }) {
      this.printingLoading = true;
      this.openLoadingPrintingModal();

      this.printAndTransmit([
        {
          batchIdentifier: this.batchSelected.barcode,
          sampleSortColumn: this.getSampleSortColumn(this.batchSelected?.printSortSelected?.value),
          printOnlyBatchTag: printOnlySamplesPrinted === null ? false : this.areAllSamplesPrinted || this.isBatchFromWS,
          onlySamplesPrinted: printOnlySamplesPrinted,
        },
      ])
        .then(response => {
          if (response === 503) {
            this.closeLoadingPrintingModal();
          } else {
            this.printingLoading = false;
          }
        })
        .catch(() => {
          this.printingLoading = false;
          this.closeLoadingPrintingModal();
        });
    },
    printBatchAndSamplesWeb({ printOnlySamplesPrinted, batch }) {
      this.printingLoading = true;
      this.openLoadingPrintingModal();
      this.printAndTransmit([
        {
          batchIdentifier: this.batchSelected.barcode,
          sampleSortColumn: this.getSampleSortColumn(this.batchSelected?.printSortSelected?.value),
          printOnlyBatchTag: printOnlySamplesPrinted ? this.areAllSamplesPrinted || this.isBatchFromWS : false,
          onlySamplesPrinted: printOnlySamplesPrinted,
        },
      ]).then(response => {
        if (response === 503) {
          this.closeLoadingPrintingModal();
        } else {
          this.showPDF(batch);
          this.printingLoading = false;
        }
      });
    },
    webSocketPrintBatchTag() {
      this.printingLoading = true;
      this.openLoadingPrintingModal();
      this.batchSelected['printOnlyBatchTag'] = true;
      this.batchSelected['source'] = this.batch.source;

      if (!this.batchSelected.samples) {
        this.batchSelected['samples'] = [];
        this.batchSelected['barcode'] = this.batch.barcode;
      }

      this.webSocketPrintAndTransmit(this.batchSelected);
    },
    printBatchTag(batch) {
      this.printingLoading = true;
      this.openLoadingPrintingModal();
      this.printAndTransmit([
        {
          batchIdentifier: this.batch.barcode,
          printOnlyBatchTag: true,
        },
      ])
        .then(response => {
          if (response === 503) {
            this.closeLoadingPrintingModal();
          } else {
            this.printingLoading = false;
          }
        })
        .catch(() => {
          this.printingLoading = false;
          this.closeLoadingPrintingModal();
        });
      this.pushEventToAnalytics(batch.isPrinted ? 'Reimpressão de Lote WS - Impresso' : 'Impressão de Lote WS - Não Impresso');
    },
    printSamplesUnprinted() {
      this.printingLoading = true;
      this.openLoadingPrintingModal();
      this.printBatchSamples([
        {
          batchIdentifier: this.batchSelected.barcode,
          sampleSortColumn: this.getSampleSortColumn(this.batchSelected?.printSortSelected?.value),
          onlySamplesPrinted: false,
        },
      ])
        .then(response => {
          if (response === 503) {
            this.closeLoadingPrintingModal();
          } else {
            this.printingLoading = false;
          }
        })
        .catch(() => {
          this.printingLoading = false;
          this.closeLoadingPrintingModal();
        });
    },
    webSocketPrintSamplesUnprinted() {
      this.printingLoading = true;
      this.openLoadingPrintingModal();
      this.batchSelected['onlySamplesPrinted'] = false;

      this.webSocketPrintBatchSamples(this.batchSelected).then(() => {
        this.closeLoadingPrintingModal();
      });
    },
    openLoadingGettingSamplesModal() {
      this.$refs.loadingGettingSamples.open();
    },
    closeLoadingGettingSamplesModal() {
      this.$refs.loadingGettingSamples.close();
    },
    openLoadingPrintingModal() {
      if (this.$refs.printingClosedBatchModal) {
        this.$refs.printingClosedBatchModal.open();
      }
    },
    closeLoadingPrintingModal() {
      if (this.$refs.printingClosedBatchModal) {
        this.$refs.printingClosedBatchModal.close();
      }
    },
    openQuestionModal() {
      this.$refs.printOpenBatchModal.open();
    },
    closeQuestionModal() {
      this.$refs.printOpenBatchModal.close();
    },
    openQuestionWebSocketModal() {
      this.$refs.webSocketPrintOpenBatchModal.open();
    },
    closeQuestionWebSocketModal() {
      this.$refs.webSocketPrintOpenBatchModal.close();
    },
    openQuestionModalWeb() {
      this.$refs.printOpenBatchModalWeb.open();
    },
    closeQuestionModalWeb() {
      this.$refs.printOpenBatchModalWeb.close();
    },
    openLoadingReceptModal() {
      this.$refs.loadingReceiptModal.open();
    },
    closeLoadingReceptModal() {
      this.$refs.loadingReceiptModal.close();
    },
    closeAndPrint({ printOnlySamples }) {
      this.closeQuestionModal();
      if (printOnlySamples) {
        this.printSamplesUnprinted();
        this.pushEventToAnalytics('Impressão de Lote AOL - Não impresso - Aberto - Imprimir apenas amostras não impressas');
      } else {
        this.printBatchAndSamples({ printOnlySamplesPrinted: false });
        this.pushEventToAnalytics('Impressão de Lote AOL - Não impresso - Aberto - Imprimir não impressos e fechar lote');
      }
    },
    webSocketPrintCloseAndPrint({ printOnlySamples }) {
      this.closeQuestionWebSocketModal();

      if (printOnlySamples) {
        this.webSocketPrintSamplesUnprinted();
      } else {
        this.webSocketPrintBatchAndSamples({ printOnlySamplesPrinted: false });
      }
    },
    closeAndPrintWeb({ printOnlySamples, batch }) {
      this.closeQuestionModal();
      if (printOnlySamples) {
        this.printSamplesUnprinted();
        this.pushEventToAnalytics('Impressão de Lote AOL - Não impresso - Aberto - Imprimir apenas amostras não impressas');
      } else {
        this.printBatchAndSamplesWeb({ printOnlySamplesPrinted: false, batch });
        this.pushEventToAnalytics('Impressão de Lote AOL - Não impresso - Aberto - Imprimir não impressos e fechar lote');
      }
    },
    pushToBatchDetails(batch) {
      let id = batch.id;
      if (batch.source === 'AOLWS') {
        id = batch.batchIdentifier;
      }
      this.$router.push({
        path: '/print-tag/batches/' + id,
        query: {
          startDate: this.$route.query.startDate,
          endDate: this.$route.query.endDate,
          packagingType: this.$route.query.packagingType,
          tab: this.batchesCurrentTab,
        },
      });
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Lote',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      });
    },
    openConfigModal() {
      this.$refs.printerModal.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.batch-card-actions {
  width: 100%;

  .md-icon {
    height: 70%;
    border-radius: 10%;
    justify-content: flex-end;
    display: flex;
    width: 80%;
    padding: 6px;
    margin-right: 250px;
  }

  .md-button {
    display: inline-flex;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    padding: 0;
    margin-left: 0 !important;
    align-items: center;
    height: auto;
    min-height: 45px;
    white-space: nowrap;
    margin-top: 0.8em !important;
    width: 100%;
    border-radius: 3px;

    &__container-cta {
      max-width: 50em;
    }

    &__ws-source {
      margin-bottom: 17px !important;
    }

    .md-icon {
      width: 30px;
      margin: auto 0 auto 0.2em;
      float: left;
    }
    span {
      margin: auto;
      line-height: 1.3em;
      width: 78%;
      white-space: normal;
      float: left;
    }

    &:hover,
    &:focus {
      .md-icon > svg {
        .print {
          fill: white;
          transition: 1s;
        }
      }
    }
  }
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    /* IE10+ */
    .md-button {
      height: 45px;
    }
  }

  .batch-ws {
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #4a4a4a;
  }
}

.openBatchModal .md-dialog {
  width: 470px;
  .standard-modal {
    &__container-cta {
      max-width: 29em;
      display: flex;
      padding-top: 25px;

      button {
        padding: 10px 23px;
      }
    }
  }
  .md-dialog-content {
    // For IE
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      overflow-x: hidden;
    }
  }
}

.print-tag-modal-print {
  .md-dialog {
    display: flex;
    flex-direction: row;
    max-width: 65%;

    .print-tag-modal-column {
      &__one {
        width: 40%;
      }

      &__two {
        width: 49%;
        display: flex;
        flex-direction: column;
        padding-top: 1em;
        padding-bottom: 1em;
        margin: auto;

        img {
          width: 70%;
          padding: 0.3em;
        }

        .loaded {
          display: flex;
          flex-direction: row;
          justify-content: end;

          .md-icon {
            margin-right: -10px;
            z-index: 10000;
          }
        }
      }
    }
  }
}
</style>
